"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countriesAll = void 0;
// This list is sorted alphabetically by country name. If you add a new country, please re-sort the list using the following code:
// countriesAll.sort((a, b) => a.name.localeCompare(b.name));
const countriesAll = [
    {
        "id": "97",
        "name": "Afghanistan"
    },
    {
        "id": "42",
        "name": "Albania"
    },
    {
        "id": "145",
        "name": "Algeria"
    },
    {
        "id": "201",
        "name": "American Samoa"
    },
    {
        "id": "44",
        "name": "Andorra"
    },
    {
        "id": "146",
        "name": "Angola"
    },
    {
        "id": "224",
        "name": "Anguilla"
    },
    {
        "id": "49",
        "name": "Antigua and Barbuda"
    },
    {
        "id": "84",
        "name": "Argentina"
    },
    {
        "id": "98",
        "name": "Armenia"
    },
    {
        "id": "50",
        "name": "Aruba"
    },
    {
        "id": "202",
        "name": "Australia"
    },
    {
        "id": "3",
        "name": "Austria"
    },
    {
        "id": "99",
        "name": "Azerbaijan"
    },
    {
        "id": "51",
        "name": "Bahamas"
    },
    {
        "id": "100",
        "name": "Bahrain"
    },
    {
        "id": "101",
        "name": "Bangladesh"
    },
    {
        "id": "52",
        "name": "Barbados"
    },
    {
        "id": "45",
        "name": "Belarus"
    },
    {
        "id": "4",
        "name": "Belgium"
    },
    {
        "id": "53",
        "name": "Belize"
    },
    {
        "id": "147",
        "name": "Benin"
    },
    {
        "id": "54",
        "name": "Bermuda"
    },
    {
        "id": "102",
        "name": "Bhutan"
    },
    {
        "id": "85",
        "name": "Bolivia"
    },
    {
        "id": "227",
        "name": "Bonaire, Sint Eustatius and Saba"
    },
    {
        "id": "40",
        "name": "Bosnia and Herzegovina"
    },
    {
        "id": "148",
        "name": "Botswana"
    },
    {
        "id": "86",
        "name": "Brazil"
    },
    {
        "id": "55",
        "name": "British Virgin Islands"
    },
    {
        "id": "103",
        "name": "Brunei"
    },
    {
        "id": "2",
        "name": "Bulgaria"
    },
    {
        "id": "149",
        "name": "Burkina Faso"
    },
    {
        "id": "150",
        "name": "Burundi"
    },
    {
        "id": "104",
        "name": "Cambodia"
    },
    {
        "id": "151",
        "name": "Cameroon"
    },
    {
        "id": "56",
        "name": "Canada"
    },
    {
        "id": "152",
        "name": "Cape Verde"
    },
    {
        "id": "57",
        "name": "Cayman Islands"
    },
    {
        "id": "153",
        "name": "Central African Republic"
    },
    {
        "id": "154",
        "name": "Chad"
    },
    {
        "id": "87",
        "name": "Chile"
    },
    {
        "id": "105",
        "name": "China"
    },
    {
        "id": "88",
        "name": "Colombia"
    },
    {
        "id": "155",
        "name": "Comoros"
    },
    {
        "id": "156",
        "name": "Congo (Democratic Republic of the)"
    },
    {
        "id": "157",
        "name": "Congo (Republic of the)"
    },
    {
        "id": "203",
        "name": "Cook Islands"
    },
    {
        "id": "58",
        "name": "Costa Rica"
    },
    {
        "id": "158",
        "name": "Côte d'Ivoire"
    },
    {
        "id": "38",
        "name": "Croatia"
    },
    {
        "id": "59",
        "name": "Cuba"
    },
    {
        "id": "225",
        "name": "Curaçao"
    },
    {
        "id": "5",
        "name": "Cyprus"
    },
    {
        "id": "7",
        "name": "Czech Republic"
    },
    {
        "id": "6",
        "name": "Denmark"
    },
    {
        "id": "159",
        "name": "Djibouti"
    },
    {
        "id": "60",
        "name": "Dominica"
    },
    {
        "id": "61",
        "name": "Dominican Republic"
    },
    {
        "id": "89",
        "name": "Ecuador"
    },
    {
        "id": "161",
        "name": "Egypt"
    },
    {
        "id": "62",
        "name": "El Salvador"
    },
    {
        "id": "162",
        "name": "Equatorial Guinea"
    },
    {
        "id": "163",
        "name": "Eritrea"
    },
    {
        "id": "8",
        "name": "Estonia"
    },
    {
        "id": "193",
        "name": "Eswatini"
    },
    {
        "id": "164",
        "name": "Ethiopia"
    },
    {
        "id": "46",
        "name": "Faroe Islands"
    },
    {
        "id": "204",
        "name": "Fiji"
    },
    {
        "id": "9",
        "name": "Finland"
    },
    {
        "id": "10",
        "name": "France"
    },
    {
        "id": "90",
        "name": "French Guiana"
    },
    {
        "id": "205",
        "name": "French Polynesia"
    },
    {
        "id": "165",
        "name": "Gabon"
    },
    {
        "id": "166",
        "name": "Gambia"
    },
    {
        "id": "106",
        "name": "Georgia"
    },
    {
        "id": "11",
        "name": "Germany"
    },
    {
        "id": "167",
        "name": "Ghana"
    },
    {
        "id": "25",
        "name": "Greece"
    },
    {
        "id": "63",
        "name": "Greenland"
    },
    {
        "id": "64",
        "name": "Grenada"
    },
    {
        "id": "65",
        "name": "Guadeloupe"
    },
    {
        "id": "206",
        "name": "Guam"
    },
    {
        "id": "66",
        "name": "Guatemala"
    },
    {
        "id": "168",
        "name": "Guinea"
    },
    {
        "id": "169",
        "name": "Guinea-Bissau"
    },
    {
        "id": "91",
        "name": "Guyana"
    },
    {
        "id": "67",
        "name": "Haiti"
    },
    {
        "id": "68",
        "name": "Honduras"
    },
    {
        "id": "107",
        "name": "Hong Kong (SAR)"
    },
    {
        "id": "12",
        "name": "Hungary"
    },
    {
        "id": "13",
        "name": "Iceland"
    },
    {
        "id": "108",
        "name": "India"
    },
    {
        "id": "109",
        "name": "Indonesia"
    },
    {
        "id": "110",
        "name": "Iran"
    },
    {
        "id": "111",
        "name": "Iraq"
    },
    {
        "id": "14",
        "name": "Ireland"
    },
    {
        "id": "43",
        "name": "Isle of Man"
    },
    {
        "id": "112",
        "name": "Israel"
    },
    {
        "id": "15",
        "name": "Italy"
    },
    {
        "id": "69",
        "name": "Jamaica"
    },
    {
        "id": "113",
        "name": "Japan"
    },
    {
        "id": "114",
        "name": "Jordan"
    },
    {
        "id": "115",
        "name": "Kazakhstan"
    },
    {
        "id": "170",
        "name": "Kenya"
    },
    {
        "id": "207",
        "name": "Kiribati"
    },
    {
        "id": "230",
        "name": "Kosovo"
    },
    {
        "id": "118",
        "name": "Kuwait"
    },
    {
        "id": "119",
        "name": "Kyrgyzstan"
    },
    {
        "id": "120",
        "name": "Laos"
    },
    {
        "id": "16",
        "name": "Latvia"
    },
    {
        "id": "121",
        "name": "Lebanon"
    },
    {
        "id": "171",
        "name": "Lesotho"
    },
    {
        "id": "172",
        "name": "Liberia"
    },
    {
        "id": "173",
        "name": "Libya"
    },
    {
        "id": "47",
        "name": "Liechtenstein"
    },
    {
        "id": "17",
        "name": "Lithuania"
    },
    {
        "id": "34",
        "name": "Luxembourg"
    },
    {
        "id": "122",
        "name": "Macao (SAR)"
    },
    {
        "id": "174",
        "name": "Madagascar"
    },
    {
        "id": "175",
        "name": "Malawi"
    },
    {
        "id": "123",
        "name": "Malaysia"
    },
    {
        "id": "124",
        "name": "Maldives"
    },
    {
        "id": "176",
        "name": "Mali"
    },
    {
        "id": "35",
        "name": "Malta"
    },
    {
        "id": "208",
        "name": "Marshall Islands"
    },
    {
        "id": "70",
        "name": "Martinique"
    },
    {
        "id": "177",
        "name": "Mauritania"
    },
    {
        "id": "178",
        "name": "Mauritius"
    },
    {
        "id": "71",
        "name": "Mexico"
    },
    {
        "id": "209",
        "name": "Micronesia, Federated States of"
    },
    {
        "id": "37",
        "name": "Moldova"
    },
    {
        "id": "36",
        "name": "Monaco"
    },
    {
        "id": "125",
        "name": "Mongolia"
    },
    {
        "id": "39",
        "name": "Montenegro"
    },
    {
        "id": "72",
        "name": "Montserrat"
    },
    {
        "id": "179",
        "name": "Morocco"
    },
    {
        "id": "180",
        "name": "Mozambique"
    },
    {
        "id": "126",
        "name": "Myanmar"
    },
    {
        "id": "181",
        "name": "Namibia"
    },
    {
        "id": "210",
        "name": "Nauru"
    },
    {
        "id": "127",
        "name": "Nepal"
    },
    {
        "id": "1",
        "name": "Netherlands"
    },
    {
        "id": "211",
        "name": "New Caledonia"
    },
    {
        "id": "212",
        "name": "New Zealand"
    },
    {
        "id": "74",
        "name": "Nicaragua"
    },
    {
        "id": "182",
        "name": "Niger"
    },
    {
        "id": "183",
        "name": "Nigeria"
    },
    {
        "id": "213",
        "name": "Niue"
    },
    {
        "id": "116",
        "name": "North Korea"
    },
    {
        "id": "18",
        "name": "North Macedonia"
    },
    {
        "id": "229",
        "name": "Northern Cyprus, Turkish Republic of"
    },
    {
        "id": "214",
        "name": "Northern Mariana Islands"
    },
    {
        "id": "19",
        "name": "Norway"
    },
    {
        "id": "128",
        "name": "Oman"
    },
    {
        "id": "129",
        "name": "Pakistan"
    },
    {
        "id": "215",
        "name": "Palau"
    },
    {
        "id": "144",
        "name": "Palestinian Territory, Occupied"
    },
    {
        "id": "75",
        "name": "Panama"
    },
    {
        "id": "216",
        "name": "Papua New Guinea"
    },
    {
        "id": "92",
        "name": "Paraguay"
    },
    {
        "id": "93",
        "name": "Peru"
    },
    {
        "id": "130",
        "name": "Philippines"
    },
    {
        "id": "20",
        "name": "Poland"
    },
    {
        "id": "21",
        "name": "Portugal"
    },
    {
        "id": "76",
        "name": "Puerto Rico"
    },
    {
        "id": "131",
        "name": "Qatar"
    },
    {
        "id": "184",
        "name": "Réunion"
    },
    {
        "id": "33",
        "name": "Romania"
    },
    {
        "id": "22",
        "name": "Russia"
    },
    {
        "id": "185",
        "name": "Rwanda"
    },
    {
        "id": "222",
        "name": "Saint Barthélemy"
    },
    {
        "id": "77",
        "name": "Saint Kitts and Nevis"
    },
    {
        "id": "78",
        "name": "Saint Lucia"
    },
    {
        "id": "79",
        "name": "Saint Pierre and Miquelon"
    },
    {
        "id": "80",
        "name": "Saint Vincent and the Grenadines"
    },
    {
        "id": "217",
        "name": "Samoa"
    },
    {
        "id": "48",
        "name": "San Marino"
    },
    {
        "id": "186",
        "name": "São Tomé and Príncipe"
    },
    {
        "id": "132",
        "name": "Saudi Arabia"
    },
    {
        "id": "187",
        "name": "Senegal"
    },
    {
        "id": "23",
        "name": "Serbia"
    },
    {
        "id": "188",
        "name": "Seychelles"
    },
    {
        "id": "189",
        "name": "Sierra Leone"
    },
    {
        "id": "133",
        "name": "Singapore"
    },
    {
        "id": "223",
        "name": "Sint Maarten"
    },
    {
        "id": "41",
        "name": "Slovakia"
    },
    {
        "id": "31",
        "name": "Slovenia"
    },
    {
        "id": "218",
        "name": "Solomon Islands"
    },
    {
        "id": "190",
        "name": "Somalia"
    },
    {
        "id": "191",
        "name": "South Africa"
    },
    {
        "id": "117",
        "name": "South Korea"
    },
    {
        "id": "232",
        "name": "South Sudan"
    },
    {
        "id": "24",
        "name": "Spain"
    },
    {
        "id": "134",
        "name": "Sri Lanka"
    },
    {
        "id": "192",
        "name": "Sudan"
    },
    {
        "id": "94",
        "name": "Suriname"
    },
    {
        "id": "26",
        "name": "Sweden"
    },
    {
        "id": "27",
        "name": "Switzerland"
    },
    {
        "id": "135",
        "name": "Syria"
    },
    {
        "id": "136",
        "name": "Taiwan"
    },
    {
        "id": "137",
        "name": "Tajikistan"
    },
    {
        "id": "194",
        "name": "Tanzania"
    },
    {
        "id": "138",
        "name": "Thailand"
    },
    {
        "id": "160",
        "name": "Timor-Leste"
    },
    {
        "id": "195",
        "name": "Togo"
    },
    {
        "id": "219",
        "name": "Tonga"
    },
    {
        "id": "81",
        "name": "Trinidad and Tobago"
    },
    {
        "id": "196",
        "name": "Tunisia"
    },
    {
        "id": "28",
        "name": "Turkey"
    },
    {
        "id": "139",
        "name": "Turkmenistan"
    },
    {
        "id": "226",
        "name": "Turks and Caicos Islands"
    },
    {
        "id": "220",
        "name": "Tuvalu"
    },
    {
        "id": "197",
        "name": "Uganda"
    },
    {
        "id": "29",
        "name": "Ukraine"
    },
    {
        "id": "140",
        "name": "United Arab Emirates"
    },
    {
        "id": "30",
        "name": "United Kingdom"
    },
    {
        "id": "82",
        "name": "United States"
    },
    {
        "id": "83",
        "name": "United States Virgin Islands"
    },
    {
        "id": "95",
        "name": "Uruguay"
    },
    {
        "id": "141",
        "name": "Uzbekistan"
    },
    {
        "id": "221",
        "name": "Vanuatu"
    },
    {
        "id": "96",
        "name": "Venezuela"
    },
    {
        "id": "142",
        "name": "Vietnam"
    },
    {
        "id": "198",
        "name": "Western Sahara"
    },
    {
        "id": "143",
        "name": "Yemen"
    },
    {
        "id": "199",
        "name": "Zambia"
    },
    {
        "id": "200",
        "name": "Zimbabwe"
    }
];
exports.countriesAll = countriesAll;
//# sourceMappingURL=countries.js.map